module.exports = __webpack_public_path__ + "img/codigo api correios 3.fbab6ac0.png";